import { fromJS, List } from 'immutable';
import {
  ADD_OPTION,
  REMOVE_OPTION,
  REMOVE_ALL,
  SORTS_RECEIVED,
  TAGS_RECEIVED,
  SHOW_TAG,
  HIDE_TAG,
  SHOW_ALL,
  UPDATE_SORT,
} from './constants';
import { arrayContainsObj, removeObjFromArray } from '../../utils/common';

// The initial state of the App
export const initialState = fromJS({
  tags: new List(),
  selectedTags: new List(),
  sorts: new List(),
  selectedSort: 'date',
});

function filtersReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_OPTION:
      const item = { value: action.value, label: action.label };
      let list = state.getIn(['selectedTags']);
      if( list === undefined || list === null ) return state;
      list = list.toArray();
      if (!arrayContainsObj(list, item, 'value'))
        return state.updateIn(['selectedTags'], elem => elem.push(item));
      return state;
    case REMOVE_OPTION:
      let elems = state.getIn(['selectedTags']);
      if( elems === undefined || elems === null ) return state.setIn(['selectedTags'], new List([]));
      elems = elems.toArray();
      elems = removeObjFromArray(elems, { value: action.value }, 'value');
      return state.setIn(['selectedTags'], new List(elems));
    case REMOVE_ALL:
      return state.setIn(['selectedTags'], new List([]));
    case TAGS_RECEIVED:
      return state.setIn(['tags'], new List(action.tags));
    case SHOW_TAG:
      let tagShowList = state.getIn(['tags']).toArray();
      tagShowList = updateTagStatus(tagShowList, action.value, true);
      return state.setIn(['tags'], new List(tagShowList));
    case HIDE_TAG:
      let tagHideList = state.getIn(['tags']).toArray();
      tagHideList = updateTagStatus(tagHideList, action.value, false);
      return state.setIn(['tags'], new List(tagHideList));
    case SHOW_ALL:
      let tagsList = state.getIn(['tags']).toArray();
      tagsList = updateAllTags(tagsList, true);
      return state.setIn(['tags'], new List(tagsList));
    case SORTS_RECEIVED:
      return state.setIn(['sorts'], new List(action.sorts));
    case UPDATE_SORT:
      return state.set('selectedSort', action.sort);
    default:
      return state;
  }
}

/**
 *
 * @param tags
 * @param value
 * @param status
 * @returns {*}
 */
function updateTagStatus(tags, value, status) {
  return tags.map(
    item => (item.value === value ? { ...item, show: status } : item),
  );
}

/**
 *
 * @param tags
 * @param status
 * @returns {*}
 */
function updateAllTags(tags, status) {
  return tags.map(item => ({ ...item, show: status }));
}

export default filtersReducer;
